import React from 'react';

import { Text } from '@atlaskit/primitives/compiled/text';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { Color } from '@atlaskit/status/status';
import { Status } from '@atlaskit/status/status';

export const StatusComponent = ({
	text,
	color,
	statusStyle,
	isBold,
}: {
	text: string;
	color: Color;
	statusStyle?: 'bold' | 'mixedCase';
	isBold: boolean;
}): React.JSX.Element => {
	const displayText =
		statusStyle !== 'mixedCase' && fg('platform-dst-lozenge-tag-badge-visual-uplifts')
			? text.toUpperCase()
			: text;

	return (
		<Text as="span" testId="status-component">
			<Status text={displayText} color={color} isBold={isBold} />
		</Text>
	);
};
